export const STATE = 'session'

export const SIGN_IN = `${STATE}/SIGN_IN`

export const GET_USERS = `${STATE}/GET_USERS`
export const CREATE_POST = `${STATE}/CREATE_POST`

export const GOOGLE_ID = `${STATE}/GOOGLE_ID`
export const STORY_AUTH = `${STATE}/STORY_AUTH`
export const SET_CHAT_REQUESTS_STORY_ID = `${STATE}/CHAT_REQUESTS_STORY_ID`
export const SET_NOT_REGISTER_STORY = `${STATE}/NOT_REGISTER_STORY`
